export default __webpack_public_path__ + "static/media/FlyingFrog24.9a30bb0b.png";